
import Vue from "vue";
import { Browse } from "@/models/browse";
import { ModelNamedProperty } from "@/utils/models/named-property";
import { ISelectItem } from "winfakt-vue-components";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	props: {
		value: {
			type: String
		},
		browse: {
			type: Object as ()=>Browse,
			required: true
		},
		column: {
			type: String,
			required: true
		},
		label: {
			type: [String, Object as ()=>TranslateResult],
			default(){
				return this.$ct("column-json-property");
			}
		},
		fancy: Boolean
	},
	computed: {
		modelProperty():ModelNamedProperty | undefined {
			if (!this.column) return undefined;
			return this.browse.type.getField(this.column);
		},
		options():ISelectItem<string>[]{
			if (!this.modelProperty) return [];
			if (!this.modelProperty.field.getJsonPropAutofillItems) return [];
			return this.modelProperty.field.getJsonPropAutofillItems();
		},
		filteredOptions():ISelectItem<string>[] {
			let inputText = this.value.toLowerCase();
			return this.options.filter(o=>{
				return o.text.toString().indexOf(inputText) != -1 || o.value.indexOf(this.value) != -1;
			});
		}
	},
	methods: {
		setValue(input:string){
			this.$emit("input", input);
		},
		optionClicked(item:ISelectItem<string>){
			this.setValue(item.value);
		}
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}

});
